/**
 * Universal Shopify Wishlist Script
 * Deduplicated, Unlimited Product Support, Single-Click Add/Remove Toggle
 */
; (function (Wishlist, $) {

    var WISHLIST_STORAGE_KEY = 'user_wishlist';
    var isProcessing = false;

    /* Normalize handle to clean, lowercase string */
    var normalizeHandle = function (handle) {
        if (!handle) return '';
        return handle.toString()
            .toLowerCase()
            .trim()
            .replace(/^\/products\//, '')
            .replace(/\/$/, '')
            .replace(/\?.*$/, '')
            .replace(/#.*$/, '');
    };

    /* Get wishlist array from localStorage safely (100% deduplicated) */
    var getWishlist = function () {
        try {
            var stored = localStorage.getItem(WISHLIST_STORAGE_KEY) || localStorage.getItem('wishlist');
            if (stored) {
                var parsed = JSON.parse(stored);
                if (Array.isArray(parsed)) {
                    // Strictly deduplicate and normalize
                    return Array.from(new Set(parsed.map(normalizeHandle).filter(Boolean)));
                }
            }
        } catch (e) {
            console.error('Error reading wishlist from localStorage', e);
        }
        return [];
    };

    /* Save wishlist array to localStorage (strictly deduplicated & synced) */
    var saveWishlist = function (wishlist) {
        try {
            var cleanWishlist = Array.from(new Set(wishlist.map(normalizeHandle).filter(Boolean)));
            var jsonStr = JSON.stringify(cleanWishlist);
            localStorage.setItem(WISHLIST_STORAGE_KEY, jsonStr);
            localStorage.setItem('wishlist', jsonStr);
        } catch (e) {
            console.error('Error saving wishlist to localStorage', e);
        }
    };

    /* Robustly extract product handle from element or parent */
    var getProductHandle = function (self) {
        var $el = $(self);

        // Exclude general wishlist page navigation links
        var href = $el.attr('href');
        if (href && (href === '/pages/wishlist' || href.indexOf('/pages/wishlist') > -1)) {
            return '';
        }

        var handle = $el.attr('data-product-handle') ||
            $el.attr('data-handle') ||
            $el.data('product-handle') ||
            $el.data('handle');

        if (!handle) {
            handle = $el.closest('[data-product-handle]').attr('data-product-handle') ||
                $el.closest('[data-handle]').attr('data-handle') ||
                $el.closest('.product-grid-item, .single-product-wrap, .product-tile, .product-single').find('[data-product-handle]').attr('data-product-handle') ||
                $el.closest('.product-grid-item, .single-product-wrap, .product-tile, .product-single').find('[data-handle]').attr('data-handle');
        }

        // Fallback from URL ONLY if on product page and element is NOT in header/navigation
        if (!handle && window.location.pathname.indexOf('/products/') > -1) {
            if (!$el.closest('header, nav, footer, .header, .footer, .site-header, .site-footer').length) {
                var parts = window.location.pathname.split('/products/');
                if (parts.length > 1) {
                    handle = parts[1].split('?')[0].split('#')[0].replace(/\/$/, '');
                }
            }
        }

        return normalizeHandle(handle);
    };

    /* Toggle button active state & heart icon visuals (Filled when in wishlist, Outline when removed) */
    var animateWishlist = function (self, isActive) {
        var $btn = $(self);
        if (isActive) {
            $btn.addClass('is-active active added');
            $btn.attr('aria-checked', 'true');
            // FontAwesome 4 (fa-heart filled, fa-heart-o outline)
            $btn.find('.fa, i, svg').removeClass('fa-heart-o').addClass('fa-heart');
            // FontAwesome 5/6 (fas/fa-solid filled, far/fa-regular outline)
            $btn.find('i, svg').removeClass('far fa-regular').addClass('fas fa-solid');
        } else {
            $btn.removeClass('is-active active added');
            $btn.attr('aria-checked', 'false');
            // FontAwesome 4 (fa-heart-o outline, fa-heart filled)
            $btn.find('.fa, i, svg').removeClass('fa-heart').addClass('fa-heart-o');
            // FontAwesome 5/6 (far/fa-regular outline, fas/fa-solid filled)
            $btn.find('i, svg').removeClass('fas fa-solid').addClass('far fa-regular');
        }
    };

    /* Sync all wishlist buttons across the page with current localStorage state */
    var activateItemsInWishlist = function () {
        var wishlist = getWishlist();
        $('.wishlist-btn, .action-wishlist, .add-to-wishlist').each(function () {
            var handle = getProductHandle(this);
            if (handle) {
                var isInWishlist = wishlist.indexOf(handle) > -1;
                animateWishlist(this, isInWishlist);
            }
        });
    };

    /* Add or remove item from wishlist */
    var updateWishlist = function (self) {
        var productHandle = getProductHandle(self);
        if (!productHandle) {
            console.warn('Wishlist: Product handle could not be determined for button', self);
            return;
        }

        var wishlist = getWishlist();
        var index = wishlist.indexOf(productHandle);

        if (index > -1) {
            /* REMOVE FROM WISHLIST -> Switches heart icon back to OUTLINE */
            wishlist.splice(index, 1);
            saveWishlist(wishlist);

            // Re-sync all buttons on page
            activateItemsInWishlist();

            // If on wishlist page, remove the product tile smoothly
            if (window.location.pathname.indexOf('/pages/wishlist') > -1) {
                $('.wishlist-tile-container[data-product-handle="' + productHandle + '"]').fadeOut(300, function () {
                    $(this).remove();
                    checkEmptyWishlist();
                });
            }
        } else {
            /* ADD TO WISHLIST -> Switches heart icon to FILLED */
            wishlist.push(productHandle);
            saveWishlist(wishlist);

            // Re-sync all buttons on page
            activateItemsInWishlist();
        }
    };

    /* Check if wishlist page is empty and show empty notice */
    var checkEmptyWishlist = function () {
        var count = $('#wishlist-grid-container .wishlist-tile-container:visible').length;
        $('.wishlist-loader').hide();
        if (count === 0) {
            $('.wishlist-grid--empty-list').fadeIn(300);
        } else {
            $('.wishlist-grid--empty-list').hide();
        }
    };

    /* Format money helper (Guarantees Rupee Rs. formatting) */
    var formatMoney = function (cents) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var formatString = 'Rs. {{amount}}';
        if (typeof Shopify !== 'undefined' && Shopify.money_format) {
            formatString = Shopify.money_format;
        } else if (typeof window.theme !== 'undefined' && window.theme.moneyFormat) {
            formatString = window.theme.moneyFormat;
        }

        var formatted = '';
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            formatted = Shopify.formatMoney(cents, formatString);
        } else {
            var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            formatted = 'Rs. ' + amount;
        }

        // Guarantee currency symbol is Rs. if Shopify defaulted to $ or ₹
        if (formatted.indexOf('$') > -1 || formatted.indexOf('₹') > -1) {
            formatted = formatted.replace(/\$/g, 'Rs. ').replace(/₹/g, 'Rs. ');
        }

        return formatted;
    };

    /* Render a single wishlist item fetched via AJAX */
    var renderWishlistItemAJAX = function (productHandle, container, onComplete) {
        var cleanHandle = normalizeHandle(productHandle);

        // Guard against duplicate DOM rendering
        if (container.find('[data-product-handle="' + cleanHandle + '"]').length > 0) {
            if (typeof onComplete === 'function') onComplete();
            return;
        }

        $.getJSON('/products/' + cleanHandle + '.js')
            .done(function (product) {
                var priceFormatted = formatMoney(product.price);
                var comparePriceFormatted = product.compare_at_price > product.price ? formatMoney(product.compare_at_price) : '';
                var featuredImg = product.featured_image ? product.featured_image : (product.images && product.images.length > 0 ? product.images[0] : '');

                var tileHtml =
                    '<div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 wishlist-tile-container" data-product-handle="' + cleanHandle + '">' +
                    '<div class="single-product-wrap card h-100 product-grid-item" style="border: 1px solid #eee; border-radius: 8px; overflow: hidden; position: relative;">' +
                    '<button type="button" class="wishlist-btn is-active remove-wishlist-btn" data-product-handle="' + cleanHandle + '" title="Remove from wishlist" style="position: absolute; top: 10px; right: 10px; z-index: 10; background: #ffffff; border: 1px solid #ddd; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #e74c3c;">' +
                    '<i class="fa fa-times"></i>' +
                    '</button>' +
                    '<div class="product-img text-center p-3">' +
                    '<a href="' + product.url + '">' +
                    '<img class="img-fluid" src="' + featuredImg + '" alt="' + product.title + '" style="max-height: 250px; object-fit: contain;">' +
                    '</a>' +
                    '</div>' +
                    '<div class="product-content card-body text-center d-flex flex-column justify-content-between p-3" style="background: #fafafa;">' +
                    '<h5 class="product-name card-title mb-2">' +
                    '<a href="' + product.url + '" style="color: #333; font-size: 16px; font-weight: 600; text-decoration: none;">' + product.title + '</a>' +
                    '</h5>' +
                    '<div class="price-box mb-3">' +
                    '<span class="new-price font-weight-bold" style="color: #111; font-size: 16px;">' + priceFormatted + '</span>' +
                    (comparePriceFormatted ? '<span class="old-price text-muted ml-2" style="text-decoration: line-through; font-size: 14px; margin-left: 8px;">' + comparePriceFormatted + '</span>' : '') +
                    '</div>' +
                    '<a href="' + product.url + '" class="btn default-btn btn-block mt-auto" style="display: flex !important; align-items: center !important; justify-content: center !important; height: 44px !important; line-height: 1 !important; margin-top: auto !important; padding: 0 15px !important; background: #111 !important; color: #fff !important; border-radius: 4px !important; font-weight: 600 !important; text-decoration: none !important; text-align: center !important;">View Product</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>';

                if (container.find('[data-product-handle="' + cleanHandle + '"]').length === 0) {
                    container.append(tileHtml);
                }
            })
            .fail(function () {
                console.warn('Wishlist: Could not fetch product details for handle: ' + cleanHandle);
            })
            .always(function () {
                if (typeof onComplete === 'function') onComplete();
            });
    };

    /* Main load logic for /pages/wishlist */
    var loadWishlistPage = function () {
        if (window.location.pathname.indexOf('/pages/wishlist') === -1) {
            return;
        }

        var wishlist = getWishlist(); // Strictly deduplicated array
        var $container = $('#wishlist-grid-container');
        $container.empty(); // Clear container to guarantee zero duplicates

        if (wishlist.length === 0) {
            $('.wishlist-loader').hide();
            $('.wishlist-grid--empty-list').show();
            return;
        }

        $('.wishlist-loader').show();
        $('.wishlist-grid--empty-list').hide();

        var loadedCount = 0;
        wishlist.forEach(function (handle) {
            renderWishlistItemAJAX(handle, $container, function () {
                loadedCount++;
                if (loadedCount >= wishlist.length) {
                    checkEmptyWishlist();
                }
            });
        });
    };

    /* Event listener bindings with event propagation & debouncing protection */
    var bindUIActions = function () {
        $(document).off('click.wishlist').on('click.wishlist', '.wishlist-btn, .action-wishlist, .add-to-wishlist', function (e) {
            var handle = getProductHandle(this);
            if (!handle && $(this).attr('href') === '/pages/wishlist') {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (isProcessing) {
                return false;
            }

            isProcessing = true;
            updateWishlist(this);

            setTimeout(function () {
                isProcessing = false;
            }, 350);

            return false;
        });
    };

    Wishlist.init = function () {
        bindUIActions();
        activateItemsInWishlist();
        loadWishlistPage();
    };

    $(document).ready(function () {
        Wishlist.init();
    });

}(window.Wishlist = window.Wishlist || {}, jQuery));

